document.addEventListener("DOMContentLoaded", function () {
  const questions = Array.from(document.querySelectorAll("#form-skin-type .question"));
  const resultSlide = document.getElementById("result-skin-type");
  const form = document.getElementById("form-skin-type");
  const progressEl = document.getElementById("quiz-progress");

  let current = 0;

  function updateProgressBar() {
    const totalSlides = questions.length;
    const clampedIndex = Math.min(current, totalSlides - 1);
    const percent = ((clampedIndex + 1) / totalSlides) * 100;
    progressEl.style.width = `${percent}%`;
  }

  function showQuestion(index) {
    current = index;
    questions.forEach((q, i) => {
      q.classList.remove("active", "prev");
      if (i === index) q.classList.add("active");
      else if (i < index) q.classList.add("prev");
    });
    resultSlide.classList.remove("active");
    updateProgressBar();
  }

  function removeDiacritics(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  function buildRoutine(products) {
    const ordre = [
      "toner",
      "serum",
      "crème",
      "crème solaire",
      "huile démaquillante",
      "nettoyant",
      "masque"
    ].map(removeDiacritics);

    const routine = [];
    const typesSeen = new Set();

    for (const type of ordre) {
      const match = products.find(p => {
        const productType = removeDiacritics(p.product_type?.trim().toLowerCase() || "");
        return productType === type && !typesSeen.has(productType);
      });
      if (match) {
        routine.push(match);
        typesSeen.add(removeDiacritics(match.product_type.trim().toLowerCase()));
      }
    }

    if (routine.length < ordre.length) {
      for (const product of products) {
        const type = removeDiacritics(product.product_type?.trim().toLowerCase() || "");
        if (type && !typesSeen.has(type)) {
          routine.push(product);
          typesSeen.add(type);
        }
        if (routine.length >= ordre.length) break;
      }
    }

    return routine;
  }

  function displayRoutine(products) {
    const routineGrid = document.getElementById("routine-grid");
    const addAllBtn = document.getElementById("add-all-to-cart");
    const finalProducts = buildRoutine(products);

    routineGrid.innerHTML = "";
    finalProducts.forEach((product, i) => {
      const div = document.createElement("div");
      div.className = "routine-item";
      div.innerHTML = `
        <div class="routine-text">
          <h2><span>${i + 1}</span>. ${product.product_type} :</h2>
          <h3>${product.title}</h3>
          <p>${product.body_html?.replace(/<[^>]+>/g, "").slice(0, 100)}...</p>
        </div>
        <div class="routine-visual">
          <img src="${product.images[0]?.src}" alt="${product.title}" />
          <a href="/products/${product.handle}" class="button">Voir le produit</a>
        </div>
      `;
      routineGrid.appendChild(div);
    });

    if (finalProducts.length) {
      addAllBtn.style.display = "block";
      addAllBtn.onclick = () => {
        finalProducts.forEach(product => {
          const variantId = product.variants[0]?.id;
          if (variantId) {
            fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: variantId, quantity: 1 }),
            });
          }
        });
        alert("Tous les produits ont été ajoutés au panier !");
      };
    }
  }

  function showResult(forcedType = null) {
    document.getElementById("skin-quiz-carousel-wrapper").style.display = "block";

    const typeCounts = {};
    const checkedInputs = form.querySelectorAll("input:checked");

    checkedInputs.forEach(input => {
      const types = input.dataset.type?.split("/") || [];
      types.forEach(type => {
        typeCounts[type] = (typeCounts[type] || 0) + parseInt(input.value || 0);
      });
    });

    let dominantType = forcedType;
    if (!dominantType) {
      let max = 0;
      for (const [type, count] of Object.entries(typeCounts)) {
        if (count > max) {
          max = count;
          dominantType = type;
        }
      }
    }

    if (!dominantType) {
      console.warn("Aucun type dominant détecté, fallback forcé.");
      dominantType = "N";
    }

    localStorage.setItem("skinType", dominantType);

    const resultTitle = document.getElementById("result-title");
    const resultDescription = document.getElementById("result-description");

    const descriptions = {
      N: "🌿 Peau <strong>mixte</strong>",
      S: "🍂 Peau <strong>sèche</strong>",
      G: "💧 Peau <strong>grasse</strong>",
      P: "🔥 Peau <strong>sensible</strong>",
      M: "☀️ Peau <strong>mature</strong>",
    };

    const details = {
      S: "Votre peau tiraille...",
      N: "Votre peau ne présente ni excès de sébum ni sècheresse marquée...",
      G: "Votre peau a tendance à briller...",
      P: "Votre peau réagit facilement...",
      M: "Avec le temps, la peau perd en collagène...",
    };

    const collectionHandles = {
      S: "peau-seche",
      G: "peau-grasse",
      P: "peau-sensible",
      M: "peau-mature",
      N: "peau-mixte",
    };

    const fallbackHandle = "tous-les-produits";
    const handle = collectionHandles[dominantType];
    const fetchUrl = handle
      ? `/collections/${handle}/products.json?limit=30`
      : `/collections/${fallbackHandle}/products.json?limit=30`;

    resultTitle.innerHTML = descriptions[dominantType] || "🤔 Type non identifié";
    resultDescription.textContent = details[dominantType] || "";
    
    console.log("Fetching routine from:", fetchUrl);
   fetch(fetchUrl)
  .then(res => {
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json();
  })
  .then(data => {
    const products = data.products || [];
    displayRoutine(products);

    const restartResultBtn = document.getElementById("restart-quiz-result");
    if (restartResultBtn) {
      restartResultBtn.style.display = "inline-block";
      restartResultBtn.onclick = () => {
        resultSlide.classList.remove("active");
        form.style.display = "block";
        showQuestion(0);
      };
    }
  })
  .catch(err => {
    console.error("Erreur chargement produits :", err);
    document.getElementById("routine-grid").innerHTML = "<p>Erreur lors du chargement.</p>";
  });

    questions.forEach(q => q.classList.remove("active", "prev"));
    resultSlide.classList.add("active");
    progressEl.style.width = "100%";
    current = questions.length;
    updateProgressBar();
  }

  function nextQuestion() {
    if (current < questions.length - 1) {
      showQuestion(current + 1);
    } else {
      showResult();
    }
  }

  questions.forEach((question) => {
    const radios = question.querySelectorAll("input[type=radio]");
    const checkboxes = question.querySelectorAll("input[type=checkbox]");

    radios.forEach(radio => {
      radio.addEventListener("change", () => {
        setTimeout(() => nextQuestion(), 300);
      });
    });

    if (question.dataset.question === "8") {
      const skipBtn = question.querySelector(".skip-btn");
      const counter = question.querySelector("#q8-counter");
      const max = 3;

      checkboxes.forEach(cb => {
        cb.addEventListener("change", () => {
          const selected = question.querySelectorAll('input[type="checkbox"]:checked');
          if (counter) counter.textContent = `${selected.length} / ${max} sélectionnées`;

          if (skipBtn) {
            if (selected.length > 0) {
              skipBtn.classList.add("animated");
              skipBtn.style.display = "inline-block";
            } else {
              skipBtn.classList.remove("animated");
              skipBtn.style.display = "none";
            }
          }

          checkboxes.forEach(other => {
            other.disabled = selected.length >= max && !other.checked;
          });
        });
      });

      if (skipBtn) {
        skipBtn.addEventListener("click", () => {
          skipBtn.style.display = "none";
          checkboxes.forEach(cb => cb.disabled = false);
          nextQuestion();
        });
      }
    } else if (checkboxes.length > 0) {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "button";
      btn.style.marginTop = "1rem";
      btn.textContent = "Suivant";
      btn.addEventListener("click", () => nextQuestion());
      question.appendChild(btn);
    }
  });

  form.style.display = "block";
  showQuestion(current);
});
